module.exports = __webpack_public_path__ + "static/HowTheExtensionWorks-869a377165db9922a08bd49b523f5912.png";